import { render, staticRenderFns } from "./HouseBLExtension.vue?vue&type=template&id=292c54e2&scoped=true&"
import script from "./HouseBLExtension.vue?vue&type=script&lang=js&"
export * from "./HouseBLExtension.vue?vue&type=script&lang=js&"
import style0 from "./HouseBLExtension.vue?vue&type=style&index=0&id=292c54e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292c54e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292c54e2')) {
      api.createRecord('292c54e2', component.options)
    } else {
      api.reload('292c54e2', component.options)
    }
    module.hot.accept("./HouseBLExtension.vue?vue&type=template&id=292c54e2&scoped=true&", function () {
      api.rerender('292c54e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/houseBL/HouseBLExtension.vue"
export default component.exports